import {reactive} from 'vue'

export const SimpleStore = reactive({
  company_orders_filters: {},
  daycare_orders_filters: {},
  flashmessages: [],
  username: window.localStorage.getItem("username"),

  hasFlashMessages() {
    return this.flashmessages.length > 0;
  },
  addFlashMessage(message, message_type) {
    this.flashmessages.push({
      'message_text': message,
      'message_type': message_type
    });
  },
  getFlashMessages() {
    return this.flashmessages;
  },
  flushFlashMessages() {
    this.flashmessages = [];
  }
})